import {
  contentCreatorRoutes,
  employeeUserRoutes,
  orgAdminRoutes,
  peerSupportRoutes,
  superAdminRoutes,
} from '@/constants/routes/app';
import sharedRoutes from '@/constants/routes/shared';
import menuMessages from '@/messages/menu';

export type TMenuOption = {
  label: string;
  navigateTo: string;
};

export const sharedOptions: TMenuOption[] = [
  {
    label: menuMessages.settings,
    navigateTo: sharedRoutes.settings,
  },
  {
    label: menuMessages.contactSupport,
    navigateTo: sharedRoutes.contactSupport,
  },
];

export const employeeRoleMenuOptions: TMenuOption[] = [
  {
    label: menuMessages.myDash,
    navigateTo: employeeUserRoutes.userDashboard,
  },
  {
    label: menuMessages.myProfile,
    navigateTo: employeeUserRoutes.userProfile,
  },
  ...sharedOptions,
];

export const orgAdminRoleMenuOptions: TMenuOption[] = [
  {
    label: menuMessages.organizationDash,
    navigateTo: orgAdminRoutes.organizationDashboard,
  },
  {
    label: menuMessages.organizationRoster,
    navigateTo: orgAdminRoutes.organizationRoster,
  },
];

export const peerSupportRoleMenuOptions: TMenuOption[] = [
  { label: menuMessages.peerSupportDashboard, navigateTo: peerSupportRoutes.peerSupportDashboard },
];

export const creatorProfileMenuOption: TMenuOption = {
  label: menuMessages.creatorProfile,
  navigateTo: contentCreatorRoutes.creatorProfile,
};

export const superAdminMenuOptions: TMenuOption[] = [
  {
    label: menuMessages.organizationDash,
    navigateTo: superAdminRoutes.organizationDashboard,
  },
  {
    label: menuMessages.peerSupportDashboard,
    navigateTo: superAdminRoutes.peerSupportDashboard,
  },
  {
    label: menuMessages.organizationRoster,
    navigateTo: superAdminRoutes.organizationRoster,
  },
  {
    label: 'Peer Support Directory',
    navigateTo: superAdminRoutes.peerSupportDirectory,
  },
  {
    label: 'Providers Directory',
    navigateTo: superAdminRoutes.providersDirectory,
  },
  {
    label: 'Member Care Directory',
    navigateTo: superAdminRoutes.memberCareDirectory,
  },
];
